import type { CardLayout } from '../../types';
import { Card } from '../Card';

import type { UefatvEditorialContent } from '@shared-types/uefatv.types';

export const Cards = ({
  items,
  layout = { cardFormat: 'wide', orientation: 'portrait', hideDescription: false },
  grouped = false,
  id = '',
}: {
  id?: string;
  items: UefatvEditorialContent[];
  layout?: CardLayout;
  grouped?: boolean;
}) => {
  return (
    <>
      {items?.map((c: UefatvEditorialContent) => {
        return <Card key={c.id} item={c} layout={layout} grouped={grouped} bucketId={id} />;
      })}
    </>
  );
};
